<div class="h-full w-full flex flex-col">
    <!-- Day Labels -->
    <div
        class="w-full flex flex-row items-center justify-center h-[32]"
        [style.width]="toolbarWidth">
        <span class="w-10 md:w-[57px] mr-[3px]"></span>
        @for (day of days; track day.startOfDayInMs; let i = $index) {
            <div
                class="h-full flex-1 text-left border-latte last:rounded-tr-lg border-r border-t border-b p-2"
                [ngClass]="{ 'rounded-tl-lg border-l': i === 0, 'bg-oatmilk': day.isToday }"
                ><span
                    class="font-inter text-bluegrey-2 text-14 font-medium"
                    [ngClass]="{ 'text-blurple-light': day.isToday }"
                    >{{ day.startOfDayInMs | epochToTime: 'ddd D' : this.timezone }}</span
                ></div
            >
        }
    </div>

    <!-- Timeslots -->
    <div #scrollPanel class="w-full h-[calc(100%_-_36px)] overflow-y-auto">
        <!-- <p-scrollpanel #scrollPanel [style]="{ width: '100%', height: '100%' }"> -->
        <div class="flex flex-row">
            <fm-calendar-timeslot-labels
                [timeFormat]="timeFormat"
                class="w-10 md:w-[57px] mr-[3px]" />
            @for (day of days; track day.startOfDayInMs; let i = $index) {
                <fm-calendar-day
                    [isToday]="day.isToday"
                    [dayData]="calendarDayData[i]"
                    [sessionDuration]="sessionDuration"
                    [timezone]="timezone"
                    [timeFormat]="timeFormat"
                    class="flex-grow border-r border-latte last:rounded-br-lg"
                    [ngClass]="{ 'border-x border-x-latte rounded-bl-lg': i === 0 }" />
            }
        </div>
        <!-- </p-scrollpanel> -->
    </div>
</div>
